import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/authService';
import { can } from '../utils/permission';

/**
 * Protected Route Component
 * - Redirects to /login if not authenticated
 * - Checks permission using can() function
 */
function ProtectedRoute({ children, permission }) {
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If permission is specified, check it
  if (permission && !can(permission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

export default ProtectedRoute;